import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { InstantSearch, Configure, useInstantSearch } from 'react-instantsearch';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import { PagesResults } from '../../commons/helpers';
const SearchSectionCountTracker = t0 => {
  const $ = _c(6);
  const {
    onCountChange
  } = t0;
  const {
    results
  } = useInstantSearch();
  let t1;
  if ($[0] !== onCountChange || $[1] !== results?.nbHits) {
    t1 = () => {
      const count = results?.nbHits;
      if (typeof onCountChange === "function" && Number.isFinite(count)) {
        onCountChange(count);
      }
    };
    $[0] = onCountChange;
    $[1] = results?.nbHits;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = results?.nbHits;
  let t3;
  if ($[3] !== onCountChange || $[4] !== t2) {
    t3 = [t2, onCountChange];
    $[3] = onCountChange;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t1, t3);
  return null;
};
const SearchPagesContent = t0 => {
  const $ = _c(17);
  const {
    facetFilters,
    indexName,
    page,
    query,
    searchState,
    searchStateQuery,
    toggleIsSearchOpen,
    updateSearchPage,
    onSectionCountChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["is_active=1", "show_in_search=1", "fk_store_id=1"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== facetFilters || $[2] !== searchStateQuery) {
    t2 = <Configure query={searchStateQuery} hitsPerPage={9} facetFilters={facetFilters} numericFilters={t1} />;
    $[1] = facetFilters;
    $[2] = searchStateQuery;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onSectionCountChange) {
    t3 = <SearchSectionCountTracker onCountChange={onSectionCountChange} />;
    $[4] = onSectionCountChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== page || $[7] !== query || $[8] !== toggleIsSearchOpen || $[9] !== updateSearchPage) {
    t4 = <PagesResults toggleSearchOpen={toggleIsSearchOpen} onLoadMore={updateSearchPage} query={query} currentPage={page} variant="advanced-search" />;
    $[6] = page;
    $[7] = query;
    $[8] = toggleIsSearchOpen;
    $[9] = updateSearchPage;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== indexName || $[12] !== searchState || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <div className="w-full"><InstantSearch searchClient={searchClient} searchState={searchState} indexName={indexName}>{t2}{t3}{t4}</InstantSearch></div>;
    $[11] = indexName;
    $[12] = searchState;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default SearchPagesContent;